import { Injectable } from '@angular/core';

import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';

import { finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.loaderService.isLoading$.next(true);

    return next.handle(req).pipe(
      finalize(() => {
        setTimeout(() => {
          this.loaderService.isLoading$.next(false);
        }, 3000);
      })
    );
  }
}
